export const ONDEMAND_STATUSES = {
  PENDING: 1,
  PAYMENT: 2,
  ACCEPT: 3,
  REJECT: 4,
  CANCELLED: 5,
  AUTOCANCELLED: 6,
  PAYMENT_AUTOCANCELLED: 7,
};

export const ONDEMAND_CANCELLED_STATUSES = [
  ONDEMAND_STATUSES.REJECT,
  ONDEMAND_STATUSES.CANCELLED,
  ONDEMAND_STATUSES.AUTOCANCELLED,
  ONDEMAND_STATUSES.PAYMENT_AUTOCANCELLED,
];
